define("shared/lib/popup-instance", ["exports", "later/services/errors"], function (_exports, _errors) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.PopupInstance = _exports.PopupCancelledError = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/services/errors"eaimeta@70e063a35619d71f
  function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateFieldGet2(e, t) { var r = _classPrivateFieldGet(t, e); return _classApplyDescriptorGet(e, r); }
  function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
  function _classPrivateFieldSet(e, t, r) { var s = _classPrivateFieldGet(t, e); return _classApplyDescriptorSet(e, s, r), r; }
  function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _classApplyDescriptorSet(e, t, l) { if (t.set) t.set.call(e, l);else { if (!t.writable) throw new TypeError("attempted to set read only private field"); t.value = l; } }
  /**
   * Thrown by PopupInstance when the popup was closed by the user (or unloaded)
   * before it posted a completion message. Callers should treat this as a soft
   * cancel — not an error worth alerting on.
   */
  class PopupCancelledError extends Error {
    constructor(message) {
      super(message);
      this.name = 'PopupCancelledError';
      // Preserve prototype chain across the ES5-transpile target (Babel).
      Object.setPrototypeOf(this, PopupCancelledError.prototype);
    }
  }

  /**
   * Window features can be read about here:
   * https://developer.mozilla.org/en-US/docs/Web/API/Window/open#windowfeatures
   */
  _exports.PopupCancelledError = PopupCancelledError;
  /**
   * Check whether or not a configuration object is provided by an external management class.
   * @param config Popup window configuration object
   * @returns Popup window instance is being managed by external class
   */
  function isPopupInstanceManaged(config) {
    return Boolean(config._manager);
  }

  /**
   * Converts a PopupWindowFeatures object into a string that can be used as the features parameter
   * in the window.open() method. Each feature is represented as a key-value pair, where the key is
   * the feature name and the value is either 'yes' or 'no' for boolean values, or the actual value
   * for other types.
   *
   * @param features - An object containing the features to be included in the popup window.
   * @returns A string representation of the window features.
   */
  function getWindowFeaturesString(features) {
    if (typeof features === 'string') {
      return features;
    }
    const featureEntries = Object.entries(features)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    .filter(_ref => {
      let [_, value] = _ref;
      return value !== undefined;
    }).map(_ref2 => {
      let [key, value] = _ref2;
      if (key === 'popup') {
        return key;
      }
      if (typeof value === 'boolean') {
        return `${key}=${value ? 'yes' : 'no'}`;
      }
      return `${key}=${value}`;
    });
    return featureEntries.join(',');
  }

  /**
   * PopupInstance holds reference to a popup `window` context. It also wraps functionality
   * for opening and closing the popup, sending messages to the parent `window` context,
   * and waiting for those messages asynchronously.
   *
   * To define the data type that the Popup instance will send back to the parent (if any)
   * define the `TMessageData` type parameter when creating or fetching an existing popup.
   */
  var _config = /*#__PURE__*/new WeakMap();
  var _logger = /*#__PURE__*/new WeakMap();
  var _popupWindow = /*#__PURE__*/new WeakMap();
  var _pollingTimer = /*#__PURE__*/new WeakMap();
  var _messageEventHandler = /*#__PURE__*/new WeakMap();
  var _unloadEventHandler = /*#__PURE__*/new WeakMap();
  class PopupInstance {
    constructor(args) {
      var _this = this;
      _defineProperty(this, "name", void 0);
      _classPrivateFieldInitSpec(this, _config, {
        writable: true,
        value: void 0
      });
      _classPrivateFieldInitSpec(this, _logger, {
        writable: true,
        value: void 0
      });
      _classPrivateFieldInitSpec(this, _popupWindow, {
        writable: true,
        value: void 0
      });
      _classPrivateFieldInitSpec(this, _pollingTimer, {
        writable: true,
        value: void 0
      });
      _classPrivateFieldInitSpec(this, _messageEventHandler, {
        writable: true,
        value: void 0
      });
      _classPrivateFieldInitSpec(this, _unloadEventHandler, {
        writable: true,
        value: void 0
      });
      this.name = args.name;
      _classPrivateFieldSet(this, _config, args.config);
      _classPrivateFieldSet(this, _logger, function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return console.debug(`[PopupInstance::${_this.name}] DEBUG: `, ...args);
      });
    }
    get isOpen() {
      if (!_classPrivateFieldGet2(this, _popupWindow)) {
        return false;
      }
      return !_classPrivateFieldGet2(this, _popupWindow).closed;
    }
    async open(opts) {
      const args = {
        features: {
          popup: true
        },
        ...(opts || {})
      };
      const target = '_blank';
      const features = getWindowFeaturesString(args.features);
      try {
        _classPrivateFieldGet2(this, _logger).call(this, 'Attempting to open popup window ...', {
          url: _classPrivateFieldGet2(this, _config).url,
          target,
          features
        });
        let popupWindow = window.open(_classPrivateFieldGet2(this, _config).url, target, features);
        if (!popupWindow) {
          _classPrivateFieldGet2(this, _logger).call(this, 'Failed to open popup window, attempting to open with custom window features ...');
          // Note: in some cases, a browser may not allow the opening of a new Popup window. In this case
          // we attempt to open a new tab instead.
          popupWindow = window.open(_classPrivateFieldGet2(this, _config).url, target);
          if (!popupWindow) {
            _classPrivateFieldGet2(this, _logger).call(this, 'Failed to open new tab');
            throw new Error('Unable to open a new Popup window or tab');
          }
        }
        _classPrivateFieldGet2(this, _logger).call(this, 'Popup window opened successfully');
        _classPrivateFieldSet(this, _popupWindow, popupWindow);
      } catch (error) {
        const reason = error instanceof Error ? error.message : String(error);
        if (isPopupInstanceManaged(_classPrivateFieldGet2(this, _config))) {
          _classPrivateFieldGet2(this, _config)._manager.onError?.(reason);
        }
        _classPrivateFieldGet2(this, _logger).call(this, 'Error opening popup window:', reason);
        throw new Error(`Unable to open Popup window: ${reason}`);
      }
      if (isPopupInstanceManaged(_classPrivateFieldGet2(this, _config))) {
        _classPrivateFieldGet2(this, _config)._manager.onOpened?.();
      }
      _classPrivateFieldGet2(this, _logger).call(this, 'Popup window opened, waiting for message...');
      try {
        const data = await this.waitForMessage();
        _classPrivateFieldGet2(this, _logger).call(this, 'Received message from popup window:', data);
        return data ? data : {};
      } catch (error) {
        _classPrivateFieldGet2(this, _logger).call(this, 'Error while waiting for message:', error);
        this.close();
        throw error;
      }
    }
    close() {
      _classPrivateFieldGet2(this, _logger).call(this, 'Closing popup window...');
      if (!_classPrivateFieldGet2(this, _popupWindow)) {
        if (isPopupInstanceManaged(_classPrivateFieldGet2(this, _config))) {
          _classPrivateFieldGet2(this, _config)._manager.onError("Popup cannot be closed because it isn't open.", _errors.ErrorSeverity.Warning);
        }
        _classPrivateFieldGet2(this, _logger).call(this, 'Popup cannot be closed because it is not open.');
        return;
      }
      _classPrivateFieldGet2(this, _logger).call(this, 'Closing popup window reference...');
      _classPrivateFieldGet2(this, _popupWindow).close();
      this.teardown();
      if (isPopupInstanceManaged(_classPrivateFieldGet2(this, _config))) {
        _classPrivateFieldGet2(this, _config)._manager.onClosed?.();
      }
      _classPrivateFieldGet2(this, _logger).call(this, 'Popup window closed.');
    }
    sendMessage(data) {
      try {
        _classPrivateFieldGet2(this, _popupWindow)?.opener.postMessage(data, window.location.origin);
        if (isPopupInstanceManaged(_classPrivateFieldGet2(this, _config))) {
          _classPrivateFieldGet2(this, _config)._manager.onMessageSent?.(data);
        }
        _classPrivateFieldGet2(this, _logger).call(this, 'Sent message to popup window:', data);
      } catch (error) {
        if (isPopupInstanceManaged(_classPrivateFieldGet2(this, _config))) {
          _classPrivateFieldGet2(this, _config)._manager.onError(`An error occurred while attempting to send a message to popup: ${error}`);
        }
        _classPrivateFieldGet2(this, _logger).call(this, 'Error sending message to popup window:', error);
      }
    }
    async waitForMessage() {
      _classPrivateFieldGet2(this, _logger).call(this, 'Waiting for message from popup window...');
      try {
        return await new Promise((resolve, reject) => {
          _classPrivateFieldGet2(this, _logger).call(this, 'Setting up message listener and polling interval...');
          this.setup({
            resolve,
            reject
          });
        }).then(data => {
          _classPrivateFieldGet2(this, _logger).call(this, 'Received message from popup window:', data);
          this.teardown();
          return data;
        });
      } catch (error) {
        _classPrivateFieldGet2(this, _logger).call(this, 'Error while waiting for message:', error);
        this.teardown();
        throw error;
      }
    }
    setup(args) {
      _classPrivateFieldGet2(this, _logger).call(this, 'Setting up message event handler and polling interval...');
      this.setupMessageEventHandler(args.resolve);
      this.setupUnloadEventHandler(args.reject);
      this.setPollingInterval(args.reject);
    }
    teardown() {
      _classPrivateFieldGet2(this, _logger).call(this, 'Tearing down message event handler and polling interval...');
      this.teardownMessageEventHandler();
      this.teardownUnloadEventHandler();
      this.clearPollingInterval();
    }
    setupMessageEventHandler(resolve) {
      if (_classPrivateFieldGet2(this, _messageEventHandler)) {
        _classPrivateFieldGet2(this, _logger).call(this, 'Tearing down existing message event handler...');
        this.teardownMessageEventHandler();
      }
      _classPrivateFieldGet2(this, _logger).call(this, 'Setting up new message event handler...');
      _classPrivateFieldSet(this, _messageEventHandler, event => {
        // Note: only accept messages from our own origin (i.e. *.later.com)
        if (event.origin !== window.location.origin) {
          _classPrivateFieldGet2(this, _logger).call(this, 'Received message from untrusted origin:', event.origin);
          return;
        }

        // Browser extensions (React DevTools, Redux DevTools, etc.) post messages to
        // the parent window on page load and share the parent's origin, so the origin
        // check alone lets them through. Verify the message actually came from the
        // popup we opened.
        if (event.source !== _classPrivateFieldGet2(this, _popupWindow)) {
          _classPrivateFieldGet2(this, _logger).call(this, 'Received message from unexpected source (not the popup window):', event.data);
          return;
        }
        if (isPopupInstanceManaged(_classPrivateFieldGet2(this, _config))) {
          _classPrivateFieldGet2(this, _config)._manager.onMessageReceived?.(event);
        }
        _classPrivateFieldGet2(this, _logger).call(this, 'Received message from popup window:', event.data);
        resolve(event.data);
      });
      window.addEventListener(PopupInstance.WINDOW_MESSAGE_EVENT_ID, _classPrivateFieldGet2(this, _messageEventHandler));
    }
    teardownMessageEventHandler() {
      if (!_classPrivateFieldGet2(this, _messageEventHandler)) {
        _classPrivateFieldGet2(this, _logger).call(this, 'No message event handler to tear down.');
        return;
      }
      _classPrivateFieldGet2(this, _logger).call(this, 'Tearing down message event handler...');
      window.removeEventListener(PopupInstance.WINDOW_MESSAGE_EVENT_ID, _classPrivateFieldGet2(this, _messageEventHandler));
      _classPrivateFieldSet(this, _messageEventHandler, undefined);
    }
    setupUnloadEventHandler(reject) {
      if (_classPrivateFieldGet2(this, _unloadEventHandler)) {
        _classPrivateFieldGet2(this, _logger).call(this, 'Tearing down existing unload event handler...');
        this.teardownUnloadEventHandler();
      }
      _classPrivateFieldGet2(this, _logger).call(this, 'Setting up new unload event handler...');
      _classPrivateFieldSet(this, _unloadEventHandler, () => {
        const unloadError = new Error(`Popup window "${this.name}" has been unloaded.`);
        _classPrivateFieldGet2(this, _logger).call(this, 'Popup window unloaded:', unloadError);
        this.close();
        reject(unloadError);
      });
      window.addEventListener(PopupInstance.WINDOW_UNLOAD_EVENT_ID, _classPrivateFieldGet2(this, _unloadEventHandler));
    }
    teardownUnloadEventHandler() {
      if (!_classPrivateFieldGet2(this, _unloadEventHandler)) {
        _classPrivateFieldGet2(this, _logger).call(this, 'No unload event handler to tear down.');
        return;
      }
      _classPrivateFieldGet2(this, _logger).call(this, 'Tearing down unload event handler...');
      window.removeEventListener(PopupInstance.WINDOW_UNLOAD_EVENT_ID, _classPrivateFieldGet2(this, _unloadEventHandler));
      _classPrivateFieldSet(this, _unloadEventHandler, undefined);
    }
    setPollingInterval(reject) {
      const windowPollingMs = _classPrivateFieldGet2(this, _config).pollingIntervalMs ?? 500;
      let pollingErrorTimeout;
      _classPrivateFieldGet2(this, _logger).call(this, 'Setting up polling interval:', `${windowPollingMs}ms`);

      // Note: stop any existing polling intervals before creating another
      this.clearPollingInterval();

      // Note: create a polling interval to check on the state of the popup window,
      // allowing us to react in the event of a user-event (i.e. manual closing)
      _classPrivateFieldSet(this, _pollingTimer, setInterval(() => {
        if (this.isOpen) {
          return;
        }

        // Debounce the pollingError by setting a timeout
        if (pollingErrorTimeout) {
          clearTimeout(pollingErrorTimeout);
        }
        pollingErrorTimeout = setTimeout(() => {
          const pollingError = new PopupCancelledError(`Popup window "${this.name}" has been closed manually.`);
          _classPrivateFieldGet2(this, _logger).call(this, 'Popup window closed manually:', pollingError);
          this.close();
          reject(pollingError);
        }, 200); // Adjust the debounce delay as needed
      }, windowPollingMs));
    }
    clearPollingInterval() {
      if (!_classPrivateFieldGet2(this, _pollingTimer)) {
        _classPrivateFieldGet2(this, _logger).call(this, 'No polling interval to clear.');
        return;
      }
      _classPrivateFieldGet2(this, _logger).call(this, 'Clearing polling interval...');
      clearInterval(_classPrivateFieldGet2(this, _pollingTimer));
      _classPrivateFieldSet(this, _pollingTimer, undefined);
    }
  }
  _exports.PopupInstance = PopupInstance;
  _defineProperty(PopupInstance, "WINDOW_MESSAGE_EVENT_ID", 'message');
  _defineProperty(PopupInstance, "WINDOW_UNLOAD_EVENT_ID", 'beforeunload');
  var _default = _exports.default = PopupInstance;
});